// extracted by mini-css-extract-plugin
module.exports = {"inputP":"profile_inputP__2vyVz","adjustMargin":"profile_adjustMargin__3eLpy"};